module.exports = __webpack_public_path__ + "img/seventyFree.46261022.png";